import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

export const NftTermsOfUseLink: FC = () => {
    return (
        <Link
            href="/about/nft-terms-of-use/"
            dataTn="nft-terms-of-use-link"
            key="nft-terms-of-use-link"
        >
            <FormattedMessage id="nft.termsOfUseLink" defaultMessage="1stDibs' NFT Terms of Use" />
        </Link>
    );
};
